module.exports = __webpack_public_path__ + "static/media/TotalXp.80e4654b.svg";